if(!window.theme._registeredSections['announcement'] === true){
  theme.Announcement = (function() {

    function Announcement(container) {
      const announcementBar = document.querySelector('.announcement__content-wrapper');

      if (document.body.classList.contains('menu-is-expanded') && announcementBar) {
        $('.announcement__content-wrapper').slick('unslick');
      } else if (announcementBar) {
        const slideSpeed = announcementBar.getAttribute('data-slide-animation-speed') || 3000;
        const autoplaySpeed = announcementBar.getAttribute('data-slide-autoplay-speed') || 2000;
        $('.announcement__content-wrapper').slick({
          arrows: true,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          speed: slideSpeed,
          autoplaySpeed: autoplaySpeed,
          rows: 0,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: false,
                dots: false,
              },
            },
          ],
        });
      }
    }

    return Announcement;
  })();
  window.theme.sections.register('announcement', theme.Announcement);
  window.theme._registeredSections['announcement'] = true;
}